import { AxiosError } from 'axios'
import { useCallback, useState } from 'react'
import { axiosInstance } from '../../scripts/axios'
import { useUrl } from './dataHooks'

export const useFinalForm = (): {
  loading: boolean
  submit: (data: FormData, onSuccess: () => void, onError: (error: string) => void) => void
} => {
  const [loading, setLoading] = useState(false)
  const submitUrl = useUrl('submit')

  const submit = useCallback(
    (data, onSuccess, onError) => {
      if (loading || !submitUrl) {
        return
      }

      setLoading(true)

      axiosInstance
        .post(submitUrl, data)
        .then(() => {
          setLoading(false)
          onSuccess()
        })
        .catch((error: AxiosError) => {
          setLoading(false)
          onError(error.message)
        })
    },
    [loading, setLoading, submitUrl]
  )

  return {
    loading,
    submit
  }
}
